/**
 * Avvia il "save file" del browser per un Blob in memoria, usando il nome
 * file indicato. Crea un object URL temporaneo, clicca un anchor nascosto,
 * poi revoca l'URL al tick successivo (revocarlo in modo sincrono può
 * annullare il download in alcuni browser).
 *
 * No-op fuori da un ambiente browser (es. SSR/test senza DOM): così il
 * chiamante non deve guardarsi da `document`/`URL` assenti.
 */
export function triggerBrowserDownload(blob: Blob, fileName: string): void {
  if (typeof document === 'undefined' || typeof URL === 'undefined') return;

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  setTimeout(() => URL.revokeObjectURL(url), 0);
}
